/**
 * Joins class names, dropping anything falsy so conditional classes can be
 * written inline: cn('card', isOpen && 'card--open').
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default cn;
